var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2438_25119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02988 21.5297C7.52988 26.04 1.56738 26.04 1.56738 26.04C1.56738 26.04 1.56738 20.0238 6.03738 18.5103",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.455 10.9957L13.5 20.0314L7.53003 14.0076L16.485 4.97195C19.875 1.55141 23.265 1.59681 24.7125 1.8087C24.9375 1.83897 25.1475 1.94492 25.305 2.10384C25.4625 2.26276 25.5675 2.47465 25.5975 2.70168C25.8075 4.16222 25.845 7.58276 22.4625 11.0033H22.455V10.9957Z",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9625 12.4941V21.0909C20.9625 21.3709 20.8425 21.6358 20.6475 21.8325L16.3875 26.146C16.2525 26.2822 16.08 26.3806 15.9 26.426C15.7125 26.4714 15.5175 26.4714 15.3375 26.4109C15.1575 26.3579 14.9925 26.252 14.865 26.1082C14.7375 25.9644 14.6475 25.7904 14.61 25.6012L13.5 20.0239",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9924 6.47021H6.47241C6.19491 6.47021 5.93241 6.5913 5.73741 6.78805L1.46241 11.0864C1.32741 11.2226 1.22991 11.3967 1.18491 11.5783C1.13991 11.7675 1.13991 11.9643 1.19991 12.1459C1.25241 12.3275 1.35741 12.494 1.49991 12.6226C1.64241 12.7513 1.81491 12.8421 2.00241 12.8799L7.52991 13.9999",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2438_25119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.ae36d61643240d3e09a6555a04a8a1ef.svg";
export { ForwardRef as ReactComponent };